// Sprint 30, story-151 (calculator glossary). Mirrors mobile's
// `redesign/src/utils/calculatorUnits.utils.ts` — independently implemented, same
// mirrored-utility pattern as `taskDisplay.ts`/`taskDisplay.utils.ts` (sprint 28). Never
// imported across the web/mobile boundary; no shared package exists in this monorepo.
//
// These trade/unit symbols are identical in every locale this app ships (house style
// `docs/ux/i18n-house-style.md` §10.1) — they are read the same way on a tape measure, a
// wire-gauge chart, or a plumbing code book regardless of the app's language. They are
// therefore plain literals here, never catalog keys and never passed through
// `useTranslation('calculators')`: there is no Spanish word to look up. This keeps
// `INTENTIONALLY_IDENTICAL_KEYS` at its existing size — none of these is ever a catalog key,
// so none is a candidate for that allowlist.
export const PSI = 'PSI';
export const WSFU = 'WSFU';
export const GPM = 'GPM';
export const AWG = 'AWG';
